import {HoverMenu, HoverMenuItem} from "components/hover-menu"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import {ContactRelationship} from "models"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import RemoveRoleModal from "components/school-roles/remove-role-modal"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import {View} from "react-native"

/**
 * @typedef {object} ComponentsSchoolRolesUserCircleOptionsButtonProps
 * @property {unknown} schoolRole
 * @property {unknown} style
 */

/**
 * @typedef {object} ComponentsSchoolRolesUserCircleOptionsButtonState
 * @property {boolean} showRemoveRoleModal
 */

/**
 * @extends {ShapeComponent<ComponentsSchoolRolesUserCircleOptionsButtonProps, ComponentsSchoolRolesUserCircleOptionsButtonState>}
 */
class ComponentsSchoolRolesUserCircleOptionsButton extends ShapeComponent {
  /** @type {ComponentsSchoolRolesUserCircleOptionsButtonState} */
  state = {
    showRemoveRoleModal: false
  }

  static defaultProps = {
    style: null
  }

  static propTypes = propTypesExact({
    schoolRole: PropTypes.instanceOf(ContactRelationship).isRequired,
    style: PropTypes.object
  })

  setup() {
    const {t} = useI18n({namespace: "js.components.school_roles.user_circle.options_button"})

    this.t = t
  }

  render() {
    const {schoolRole, style} = this.p
    const actualStyle = useMemo(() => Object.assign({position: "relative"}, style), [style])

    return (
      <View
        dataSet={this.cache("rootViewStyle", {class: "components--school-roles--options-button", schoolRoleId: schoolRole.id()}, [schoolRole.id()])}
        style={actualStyle}
      >
        {this.s.showRemoveRoleModal && schoolRole.can("destroy") &&
          <RemoveRoleModal onRequestClose={this.tt.onRequestCloseRemoveRoleModal} schoolRole={schoolRole} />
        }
        <HoverMenu content={this.tt.hoverMenuContent}>
          <View style={this.iconViewStyle ||= {display: "flex", alignItems: "center", justifyContent: "center", width: 25, height: 25}}>
            <i className="fa-solid fa-ellipsis-vertical" style={this.iconStyle ||= {fontSize: 20}} />
          </View>
        </HoverMenu>
      </View>
    )
  }

  hoverMenuContent = () => {
    const {t} = this.tt
    const {schoolRole} = this.p

    return (
      <>
        {schoolRole.can("destroy") &&
          <HoverMenuItem
            dataSet={this.removeAttachmentFromSchoolPressableDataSet ||= {class: "remove-attachment-from-school-pressable"}}
            label={t(".remove_attachment_from_school")}
            onPress={this.tt.onRemoveRolePressed}
          />
        }
      </>
    )
  }

  onRemoveRolePressed = () => this.setState({showRemoveRoleModal: true})
  onRequestCloseRemoveRoleModal = () => this.setState({showRemoveRoleModal: false})
}

export default memo(shapeComponent(ComponentsSchoolRolesUserCircleOptionsButton))
